module.exports = "https://web-assets.ifttt.com/packs/media/press/forbes-5b76b118.svg";